import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validateCoverageCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CoverageState = void;

export const COVERAGE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CoverageState>>,
): ConditionType<CoverageState, Condition.Coverage> => ({
  name: "Returns covered by Redo",
  description() {
    return "Has Redo return coverage";
  },
  Details(props: ConditionTypeDetailsProps<CoverageState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.COVERAGE };
  },
  valid() {
    return validateCoverageCondition({}).valid;
  },
});
